import Axios from 'axios';
import {format, parseISO} from 'date-fns'
import {API_URL} from '../config/constants';

export const apiClient = Axios.create({
	baseURL: API_URL,
	headers: {
		'Content-Type': 'application/json'
	},
});

apiClient.interceptors.request.use(function (request) {
	const token = localStorage.getItem('access_token');
	request.headers.Authorization = token ? `Bearer ${token}` : '';
	formatDates(request.data);
	return request;
});

apiClient.interceptors.response.use(
	(response) => {
		parseDates(response.data);
		return response.data;
	},
	(error) => {

		const message =
			error.response?.data?.message || error.message;

		if (error.response?.status === 400) {
			window.location.href = '#/bad-request';
			return Promise.reject();
		}

		if (error.response?.status === 401) {
			localStorage.removeItem('access_token');
			window.location.href = '/';
			return Promise.reject();
		}

		if (error.response?.status === 403) {
			window.location.href = '#/forbidden';
			return Promise.reject();
		}

		if (error.response?.status === 404) {
			window.location.href = '#/not-found';
			return Promise.reject();
		}

		return Promise.reject(message);
	}
);

const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?/;

function isIsoDateString(value: any): boolean {
	return value && typeof value === "string" && isoDateFormat.test(value);
}

export function parseDates(body: any) {
	if (body === null || body === undefined || typeof body !== "object")
		return body;

	for (const key of Object.keys(body)) {
		const value = body[key];
		if (isIsoDateString(value)) body[key] = parseISO(value);
		else if (typeof value === "object") parseDates(value);
	}
}

function formatDates(body: any) {
	if (body === null || body === undefined || typeof body !== "object")
		return body;

	for (const key of Object.keys(body)) {
		const value = body[key];
		if (value instanceof Date) body[key] = format(value, "yyyy-MM-dd'T'HH:mm:ss");
		else if (typeof value === "object") formatDates(value);
	}
}
